/**
 * Дробит число на разряды
 */
export const numberWithDelimiter = (number: number, delimiter: string = ' ') =>
  number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);
